const curry = (f: Function) => (a: any) => (b: any) => f(a, b)

export default curry
